export const es = {
  lang: 'es',
  data: {
    'ROUTES': {
      'home': 'inicio',
      'features': 'funcionalidades',
      'pricing': 'precios',
      'faq': 'faq',
      'help': 'ayuda',
      'forum': 'forum',
      'blog': 'blog',
      'member': 'miembro',
      'login': 'iniciar-sesion',
      'dashboard': 'panel',
      'support': 'soporte',
      'tickets': 'tickets',
      'register': 'registro',
      'complete': 'finalizacion',
      'download': 'descarga',
      'contact': 'contacto',
      'profile': 'perfil',
      'general': 'general',
      'address': 'direccion',
      'company': 'empresa',
      'other': 'otros',
      'subscription': 'suscripcion',
      'manage': 'gestionar',
      'accounts': 'cuentas',
      'templates': 'plantillas',
      'apps': 'apps',
      'legal': 'legal',
      'terms': 'condiciones',
      'privacy': 'privacidad',
      'imprint': 'aviso-legal',
      'cancellation': 'cancelacion',
      'error': 'error',
      'item-management': 'gestion-articulos',
      'import-export': 'importar-exportar',
      'synchronization': 'sincronizacion',
      'orders': 'pedidos',
      'messages': 'mensajes',
      'marketing': 'marketing',
      'extra': 'extras',
      'ai': 'ia',
      'ebay-lister': 'ebay-lister',
      'gpsr': 'gpsr',
      'car-parts': 'recambios-coche',
    },
    'LEGAL': {
      'META': {
        'TERMS': {
          'TITLE': 'Condiciones generales - dewabit',
          'DESCRIPTION': 'Las condiciones generales de uso de dewabit, el software de publicación para vendedores de eBay.',
        },
        'PRIVACY': {
          'TITLE': 'Política de privacidad - dewabit',
          'DESCRIPTION': 'Cómo dewabit trata y protege los datos personales: nuestra política de privacidad de un vistazo.',
        },
        'IMPRINT': {
          'TITLE': 'Aviso legal - dewabit',
          'DESCRIPTION': 'Aviso legal e identificación del prestador BWS IT GmbH, editora de dewabit.',
        },
        'CANCELLATION': {
          'TITLE': 'Cancelar contratos aquí - dewabit',
          'DESCRIPTION': 'Cancele su suscripción a dewabit en línea - sin iniciar sesión y con confirmación de recepción inmediata.',
        },
      },
    },
    'NAV-LINKS': {
      'HOME': 'Inicio',
      'FEATURES': 'Funcionalidades',
      'EBAY-LISTER': 'eBay Lister',
      'GPSR': 'GPSR',
      'CARPARTS': 'Recambios de coche',
      'DOWNLOAD': 'Descargar',
      'PRICING': 'Precios',
      'FAQ': 'FAQ',
      'HELP-PAGES': 'Páginas de ayuda',
      'FORUMS': 'Foros',
      'BLOG': 'Blog',
      'CONTACT': 'Contacto',
      'LOGIN': 'Iniciar sesión',
      'REGISTER': 'Registrarse',
      'MEMBER': 'Área de miembros',
      'MEMBER-DASHBOARD': 'Panel',
      'MEMBER-PROFILE': 'Perfil',
      'MEMBER-SUBSCRIPTION': 'Tu plan',
      'MEMBER-EBAY-ACCOUNTS': 'Cuentas ebay',
      'MEMBER-TEMPLATES': 'Plantillas',
      'MEMBER-APPS': 'Apps',
      'MEMBER-SUPPORT': 'Soporte',
      'IMPRINT': 'Aviso legal',
      'CANCELLATION': 'Cancelar contratos aquí',
      'PRIVACY': 'Privacidad',
      'TERMS': 'Condiciones',
      'LOGOUT': 'Cerrar sesión',
      'ACCOUNT-MENU': 'Menú de cuenta',
    },
    'GLOBAL': {
      'ERROR': 'Error',
      'ERROR-GENERAL': 'Algo salió mal. Inténtelo de nuevo más tarde o contacte con nuestro soporte.',
      'SESSION-EXPIRED': 'Su sesión ha expirado, por favor inicie sesión de nuevo',
      'CANCEL': 'Cancelar',
      'TRY-AGAIN': 'Reintentar',
      'PLEASE-WAIT': 'Por favor espere',
      'ARE-YOU-SURE': '¿Está seguro?',
      'SUCCESS': 'Éxito',
      'DELETE': 'Eliminar',
      'WARNING': 'Advertencia',
      'INFO': 'Info',
      'CHARS-LEFT': 'caracteres restantes',
      'CLOSE': 'Cerrar',
      'CLOSE-WINDOW': 'Cerrar ventana',
      'COPY-TO-CLIPBOARD': 'Copiar al portapapeles',
      'YES': 'Sí',
      'NO': 'No',
      'CONFIRM': 'Confirmar',
      'SELECT': 'Seleccionar',
      'ACTIVE': 'Activo',
      'INACTIVE': 'Inactivo',
      'DEFAULT': 'Predeterminado',
      'SAVE-CHANGES': 'Guardar cambios',
      'FOOTER': {
        'IMPRINT': 'Aviso legal',
        'PRIVACY': 'Privacidad',
        'TERMS': 'Condiciones',
      },
      'UPDATE-AVAILABLE': {
        'HEAD': '¡Actualización disponible!',
        'BODY': 'Hay una nueva versión disponible. ¿Desea recargar la página ahora? Atención: ' +
          'los cambios no guardados se perderán.',
        'LATER': 'Más tarde',
        'RELOAD': 'Recargar página',
      },
      'WEBSOCKET': {
        'TICKET-REPLY': 'Ha recibido una respuesta a su ticket de soporte.'
      },
      'PAYMENT': {
        'SUBTOTAL': 'Subtotal sin IVA',
        'VAT': '{{VATPERCENT}}% de IVA sobre',
        'TOTAL': 'Total',
        'AMOUNT-TO-PAY': 'Importe a pagar',
        'CB-TERMS': 'He leído los términos y condiciones y los acepto',
        'OPEN-NEW-WINDOW': 'Abrir en una ventana nueva',
        'CB-CANCELLATION': 'Solicito y acepto que comiencen con el servicio contratado antes de que expire el plazo de desistimiento. ' +
          'Sé que mi derecho de desistimiento expira con el cumplimiento completo del contrato.',
        'CONTINUE-PAYPAL': 'Continuar a PayPal',
      },
      'LOGIN-MODAL': {
        'HEAD': 'Introduzca sus datos de acceso de dewabit para iniciar sesión:',
        'E-MAIL': 'Correo electrónico',
        'E-MAIL-PLACEHOLDER': 'Introducir correo electrónico',
        'PASSWORD': 'Contraseña',
        'PASSWORD-PLACEHOLDER': 'Introducir contraseña',
        'LOGIN': 'Iniciar sesión',
        'LOGIN-SUCCESS': 'Inicio de sesión correcto',
      },
      'COMMUNITY-PUSH': {
        'NEW-POST': 'Nueva publicación de {{user}}',
        'NEW-THREAD': 'Nuevo tema de {{user}}: {{threadName}}',
      },
      'LOGOUT-SUCCESS': 'Ha cerrado sesión correctamente',
      'CTA-REGISTER': {
        'CTA-HEAD': '¡Cree ahora su cuenta gratuita!',
        'CTA-BODY': 'Registro y prueba sin riesgo, sin necesidad de indicar datos de pago',
        'CTA-BTN': 'Registrarse ahora',
      }
    }
  },
};
